import { render } from "./Le oreal.vue?vue&type=template&id=4c195322&scoped=true"
const script = {}

import "./Le oreal.vue?vue&type=style&index=0&id=4c195322&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4c195322"

export default script